import { IBedroom, IBedroomAction } from '../../../models/filters/bedroom';

export const BEDROOM_UPDATE = 'search/BEDROOM_UPDATE';

const initialState: IBedroom = {
  bedroom: undefined,
  isDirty: false,
};

const defaultAction: IBedroomAction = {
  type: '',
  payload: {},
};

export const bedroomReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case BEDROOM_UPDATE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};

export const setBedroom = (bedroom: string): IBedroomAction => {
  return {
    type: BEDROOM_UPDATE,
    payload: {
      bedroom,
    },
  };
};

export const setDirty = (isDirty: boolean): IBedroomAction => {
  return {
    type: BEDROOM_UPDATE,
    payload: {
      isDirty,
    },
  };
};
